import React from 'react';
import { SvgIcon } from '@material-ui/core';

const BellIcon = (props) => {
  return (
      <img class="homeicon" viewBox="0 0 24 24" src="./images/bell.svg" alt="" />
  );
};

export default BellIcon;
